import React, { useCallback } from "react";
import { FlatList, StyleSheet, View } from "react-native";
import entityStyle from "@utils/entityStyle";
import { default as Text } from "../AppText";
import RenderCMSEntity from "./RenderCMSEntity";

const NxMBannerContainer = (props) => {
  const {
    cl_title = "",
    list_items = [],
    margin = false,
    layout_columns = null,
    trackEvent,
  } = props;

  const _renderItem = useCallback(
    ({ item }) => {
      return (
        <RenderCMSEntity
          fromNxM={true}
          type={item.type}
          id={item.cms_item_id}
          columns={layout_columns}
          trackEvent={trackEvent}
          {...item}
        />
      );
    },
    [layout_columns],
  );

  return (
    <View style={[{ marginHorizontal: 0, marginTop: margin ? 8 : 0 }]}>
      {cl_title ? (
        <View>
          <Text bold fontType="head2" style={styles.listHeader}>
            {cl_title}
          </Text>
        </View>
      ) : (
        <></>
      )}
      {typeof layout_columns === "number" && (
        <FlatList
          data={list_items}
          renderItem={_renderItem}
          numColumns={Math.round(layout_columns)}
          keyExtractor={(item) => `key-${item.cms_item_id}`}
          key={`${Math.round(layout_columns)}`}
        />
      )}
    </View>
  );
};

export default NxMBannerContainer;

const styles = StyleSheet.create({
  listHeader: {
    // paddingTop: 25,
    // paddingBottom: 10,
  },
});
